import { configureStore } from '@reduxjs/toolkit';
import { groupSlice } from './slices/groupSlice';
import { referenceYearSlice, ReferenceYearState } from './slices/referenceYearSlice';
import { employeeExceptionSlice, EmployeeExceptionState } from './slices/employeeExceptionSlice';
import { objectiveSlice, ObjectiveState } from './slices/objectiveSlice';
import {
    snackbarNotificationSlice,
    SnackbarNotificationState,
} from 'src/components/components/SnackbarNotification/snackbarNotificationSlice';
import { GroupState } from './slices/groupSlice';
import { officeSlice, OfficeState } from './slices/officeSlice';
import { regionSlice, RegionState } from './slices/regionSlice';
import { departmentSlice, DepartmentState } from './slices/departmentSlice';
import { businessCategorySlice, BusinessCategoryState } from './slices/businessCategorySlice';
import { dropdownSlice, DropdownState } from './slices/dropdownSlice';
import { groupTypeSlice, GroupTypeState } from './slices/groupTypeSlice';
import { groupSizeSlice, GroupSizeState } from './slices/groupSizeSlice';
import { managerSlice, ManagerState } from './slices/managerSlice';
import { managerTypeSlice, ManagerTypeState } from './slices/managerTypeSlice';
import { managerTypeGroupSizeSlice, ManagerTypeGroupSizeState } from './slices/managerTypeGroupSizeSlice';
import { baseHrLevelFamilySlice, BaseHrLevelFamilyState } from './slices/baseHrLevelFamilySlice';
import { reportSlice, ReportState } from './slices/reportSlice';
import { hierarchySlice, HierarchyState } from './slices/hierarchySlice';

export interface Reducers {
    groups: GroupState;
    groupTypes: GroupTypeState;
    groupSizes: GroupSizeState;
    referenceYears: ReferenceYearState;
    employeeExceptions: EmployeeExceptionState;
    baseHrLevelFamilies: BaseHrLevelFamilyState;
    exceptions: EmployeeExceptionState;
    objectives: ObjectiveState;
    offices: OfficeState;
    regions: RegionState;
    departments: DepartmentState;
    businessCategories: BusinessCategoryState;
    managers: ManagerState;
    managerTypes: ManagerTypeState;
    managerTypeGroupSizes: ManagerTypeGroupSizeState;
    snackbarNotifications: SnackbarNotificationState;
    dropdowns: DropdownState;
    reports: ReportState;
    hierachy: HierarchyState;
}

export const store = configureStore({
    reducer: {
        groups: groupSlice.reducer,
        groupTypes: groupTypeSlice.reducer,
        groupSizes: groupSizeSlice.reducer,
        referenceYears: referenceYearSlice.reducer,
        employeeExceptions: employeeExceptionSlice.reducer,
        baseHrLevelFamilies: baseHrLevelFamilySlice.reducer,
        objectives: objectiveSlice.reducer,
        offices: officeSlice.reducer,
        regions: regionSlice.reducer,
        reports: reportSlice.reducer,
        hierachy: hierarchySlice.reducer,
        departments: departmentSlice.reducer,
        businessCategories: businessCategorySlice.reducer,
        managers: managerSlice.reducer,
        managerTypes: managerTypeSlice.reducer,
        managerTypeGroupSizes: managerTypeGroupSizeSlice.reducer,
        snackbarNotifications: snackbarNotificationSlice.reducer,
        dropdowns: dropdownSlice.reducer,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
